import { render, staticRenderFns } from "./UsersViewAccessLogCard.vue?vue&type=template&id=a0d65ed0"
import script from "./UsersViewAccessLogCard.vue?vue&type=script&lang=js"
export * from "./UsersViewAccessLogCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports